import React from "react";

export default function DomiBanner() {
  return (
    <section id="domi" className="text-center no-padding">
      <div className="container-fluid px-0">
        <img
          src="assets/Domi.png"
          alt="Domï App Coming Soon Banner"
          className="img-fluid w-100 shadow-sm"
          style={{ height: "auto", maxWidth: "100%" }}
        />
      </div>
    </section>
  );
}
